module.exports = __webpack_public_path__ + "static/media/pareto.ef608ec9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/article-images/pareto.gif
// module id = 111
// module chunks = 0